import type { TextFieldProps } from "@mui/material/TextField";

/**
 * Shared MUI form field defaults.
 * `margin: "none"` — grids/stacks own spacing; avoids double vertical waste.
 */
export const APP_FORM_DEFAULTS = {
  variant: "outlined" as const,
  size: "small" as const,
  fullWidth: true,
  margin: "none" as const,
};

export type AppTextFieldProps = Omit<TextFieldProps, "variant" | "size"> & {
  /** Override default `small` size when needed (e.g. chat input). */
  size?: TextFieldProps["size"];
  /** Override default `outlined` variant. */
  variant?: TextFieldProps["variant"];
};
